import { roundToPrecision } from "./calculations";


export function generateYearlyResults(
  start: number,
  monthlyPayment: number,
  rate: number,
  totalMonths: number
) {
  const yearlyResults = [];
  let accumulated = start;
  let totalInvested = start;
  let totalInterest = 0;
  const years = Math.ceil(totalMonths / 12);

  for (let year = 1; year <= years; year++) {
    const monthsInThisYear = Math.min(12, totalMonths - (year - 1) * 12);
    let yearlyInvestment = 0;
    let yearlyInterest = 0;

    for (let month = 1; month <= monthsInThisYear; month++) {
      const monthlyInterest = accumulated * rate;
      yearlyInterest += monthlyInterest;
      totalInterest += monthlyInterest;
      
      accumulated = roundToPrecision(accumulated + monthlyInterest + monthlyPayment);
      yearlyInvestment += monthlyPayment;
      totalInvested += monthlyPayment;
    }

    yearlyResults.push({
      year,
      yearlyInvestment: roundToPrecision(yearlyInvestment),
      yearlyInterest: roundToPrecision(yearlyInterest),
      totalInvested: roundToPrecision(totalInvested),
      totalInterest: roundToPrecision(totalInterest),
      totalAccumulated: roundToPrecision(accumulated),
    });
  }

  return yearlyResults;
}


export function generateYearlyResultsZeroRate(
  start: number,
  monthlyPayment: number,
  totalMonths: number
) {
  const yearlyResults = [];
  let totalInvested = start;
  let accumulated = start;
  const years = Math.ceil(totalMonths / 12);

  for (let year = 1; year <= years; year++) {
    const monthsInThisYear = Math.min(12, totalMonths - (year - 1) * 12);
    const yearlyInvestment = monthlyPayment * monthsInThisYear;
    
    totalInvested += yearlyInvestment;
    accumulated += yearlyInvestment;

    yearlyResults.push({
      year,
      yearlyInvestment: roundToPrecision(yearlyInvestment),
      yearlyInterest: 0,
      totalInvested: roundToPrecision(totalInvested),
      totalInterest: 0,
      totalAccumulated: roundToPrecision(accumulated),
    });
  }

  return yearlyResults;
}


export function generateInterestRateArrays(
  start: number,
  monthlyPayment: number,
  rate: number,
  months: number
) {
  const monthlyResult: number[] = [];
  const monthlyInvested: number[] = [start];
  const monthlyTax: number[] = [];
  const monthlyAcumulatedInterest: number[] = [];

  let tempAccumulated = start;
  let tempInvested = start;
  let tempTotalInterest = 0;

  for (let i = 0; i < months; i++) {
    const monthlyInterest = tempAccumulated * rate;
    tempTotalInterest += monthlyInterest;
    
    tempAccumulated = roundToPrecision(tempAccumulated + monthlyInterest + monthlyPayment);
    tempInvested = roundToPrecision(tempInvested + monthlyPayment);

    monthlyTax.push(roundToPrecision(monthlyInterest));
    monthlyResult.push(roundToPrecision(tempTotalInterest));
    monthlyInvested.push(roundToPrecision(tempInvested));
    monthlyAcumulatedInterest.push(roundToPrecision(tempAccumulated));
  }

  return {
    monthlyResult,
    monthlyInvested,
    monthlyTax,
    monthlyAcumulatedInterest
  };
}


export function generateZeroRateArrays(
  start: number,
  monthlyPayment: number,
  months: number
) {
  const monthlyResult: number[] = [];
  const monthlyInvested: number[] = [start];
  const monthlyTax: number[] = [];
  const monthlyAcumulatedInterest: number[] = [];

  let accumulated = start;
  let totalInvested = start;

  for (let i = 0; i < months; i++) {
    accumulated += monthlyPayment;
    totalInvested += monthlyPayment;

    monthlyTax.push(0);
    monthlyResult.push(0);
    monthlyInvested.push(roundToPrecision(totalInvested));
    monthlyAcumulatedInterest.push(roundToPrecision(accumulated));
  }

  return {
    monthlyResult,
    monthlyInvested,
    monthlyTax,
    monthlyAcumulatedInterest
  };
}